<div class="wrapper text-lg-b2-s-500 text-md-b4-m-500 text-c1-l-500">
  @if (!isGift()) {
    <button type="button" class="calc" (click)="decrement()" [disabled]="disabled" tabindex="-1">
      <sd-icon type="minus" class="icon-size-xxs icon-size-md-s"></sd-icon>
    </button>
  }

  @if (!isGift()) {
    <input
      #quantityInput
      [formControl]="quantityControl"
      sdOnlyNumber="float"
      type="number"
      [min]="min()"
      [max]="max()"
      [step]="step()"
      [readonly]="readonly()"
      [class.withLabel]="!!unit()?.name"
      [tabindex]="readonly() ? -1 : 0"
      (keydown.enter)="onEnterPress()"
      (blur)="onBlur()"
      (focus)="onFocus()"
      enterkeyhint="done"
    />
  }

  @if (unit()) {
    <span class="label">
      @if (loading()) {
        <sd-loader></sd-loader>
      } @else {
        <span class="text-md-b2-s-500">{{ currentValueSignal() }} {{ unit()?.name }}</span>
        @if (showSaleUnit() && saleUnit() && computedSaleQuantity()) {
          <span>&nbsp;({{ computedSaleQuantity() }} {{ saleUnit().name }})</span>
        }
      }
    </span>
  }

  @if (!isGift()) {
    <button type="button" class="calc" (click)="increment()" [disabled]="disabled || valueExceeded()" tabindex="-1">
      <sd-icon type="plus" class="icon-size-xxs icon-size-md-s"></sd-icon>
    </button>
  }
</div>
